import React from 'react';
import Layout from '../components/Layout';

const Administrator = () => {
  return (
    <Layout title="Administrator">
      <h2 className="title is-4">Halaman Data Anggota</h2>
      <p>Ini adalah halaman untuk menampilkan dan mengelola data anggota.</p>
    </Layout>
  );
};

export default Administrator;